/*
 * @Description: 一周用户情感倾向趋势-极坐标轴图
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 10:59:40
 * @LastEditTime: 2019-04-03 11:48:12
 */

import moment from 'moment';


const createtr = (list, obj) => {
  return list.map((item, index) => `
    <tr>
      <td>${item.replace('群体', '')}</td>
      <td>${obj.kol[index].value}</td>
      <td>${obj.mua[index].value}</td>
    </tr>
  `).join('\n')
};

const createTable = (list, obj) => {
  return `
    <div style="border: 1px solid #f4f4f4; padding: 3px; color: #101010;">
      <table style="width: 150px; text-align: center; border: 1px solid #fff;font-size: 12px; background: #f3f3f3; border-collapse:collapse;">
        <tr>
          <th style="background: #e0e0e0;"></th>
          <th style="font-weight:400;background: #e0e0e0;">kol群体</th>
          <th style="font-weight:400;background: #e0e0e0;">普通群体</th>
        </tr>
        ${createtr(list, obj)}
      </table>
    </div>
  `
};

const createColor = (name, color) => ({
  value: 0,
  name: name,
  itemStyle: {
    normal: {
      color: color
    }
  }
});

const axis = ['顺意群体', '中立群体', '逆意群体'];
// 顺意普通群体颜色 (247，178，179) #f7b2b3
// 顺意 KOL 群体颜色 (249，216，213) #f9d8d5

// 中立普通群体颜色 (255，229，13) #ffe50d
// 中立 KOL 群体颜色 (255，215，13) #ffd70d

// 逆意普通群体颜色 (150，201，29) #96c91d
// 逆意 KOL 群体颜色 (96，143，15) #608f0f

const itemStyle = (value, color) => ({
  value: value,
  itemStyle: {
    normal: {
      color: color
    }
  }
})

const emotionalTendencyPolar = (data, query) => {

  const charts = data.chartsJson;

  const result = {
    mua: [
      itemStyle(charts.better.mua + charts.good.mua, '#f9d8d5'),
      itemStyle(charts.ne.mua, '#ffec8e'),
      itemStyle(charts.worse.mua + charts.bad.mua, '#73cbfb'),
    ],
    kol: [
      itemStyle(charts.better.KOL + charts.good.KOL, '#f7b1b2'),
      itemStyle(charts.ne.KOL, '#ffd70d'),
      itemStyle(charts.worse.KOL + charts.bad.KOL, '#4fb7ed'),
    ]
  };


  console.log(result);
  

  return {
    title: {
      text: `受众好感图 - ${query.brandName}`,
      subtext: query.startDate 
        ? `时间窗口：${moment(query.startDate).format('YYYY.MM.DD') } - ${moment(query.statisDate).format('YYYY.MM.DD')}`
        : '数据来源：数字品牌榜',
      x: '20'
    },
    angleAxis: {
      type: 'category',
      data: axis,
      z: 10,
      axisLine: {
        show:false
      }
    },
    radiusAxis: {
      // type: 'value',
      // minInterval: 1,
      // boundaryGap: ['20%', '20%']
    },
    polar: {
    },
    legend: {
      show: true,
      right: 20,
      bottom: 10,
      selectedMode: false,
      orient: 'vertical',
      data: ['顺意普通','顺意KOL','中立普通','中立KOL','逆意普通', '逆意KOL']
    },
    tooltip: {
      show: true,
      position: {
        left: 20,
        bottom: 10
      },
      backgroundColor: 'rgba(0,0,0,0)',
      tirgger: 'axis',
      alwaysShowContent: true,
      formatter: () => {
        return createTable(axis, result)
      }
    },
    grid: {
      left: 300
    },
    series: [{
      name: '顺意群体',
      type: 'bar',
      data: result.kol,
      coordinateSystem: 'polar',
      stack: 'a'
    }, {
      name: '逆意群体',
      type: 'bar',
      data: result.mua,
      coordinateSystem: 'polar',
      stack: 'a'
    },
    {
      type: 'pie',
      radius : '0%',
      center: [-100, -100],
      label: {
        show: true
      },
      data:[
        createColor('顺意普通', '#f9d8d5'),
        createColor('中立普通', '#ffec8e'),
        createColor('逆意普通', '#73cbfb'),
        createColor('顺意KOL', '#f7b1b2'),
        createColor('中立KOL', '#ffd70d'),
        createColor('逆意KOL', '#4fb7ed'),
      ]
    }]
  }
}

export default emotionalTendencyPolar;


// WEBPACK FOOTER //
// src/chart/emotionalTendencyPolar.js